<mat-form-field appearance="fill">
  <input
    type="text"
    matInput
    #searchInput
    [(ngModel)]="typedInput"
    placeholder="{{placeholder || ''}}"
    [matAutocomplete]="matDropdown"
    (blur)="onTouched()"
    [disabled]="disabled"
    (keyup.enter)="search()"
  />
  <button matSuffix mat-icon-button aria-label="Search" (click)="search()">
    <ng-container *ngIf="{loadingState:(loading | async)} as data">
      <mat-icon *ngIf="!(data.loadingState)">search</mat-icon>
      <mat-icon svgIcon="loadingBounce" *ngIf="data.loadingState"></mat-icon>
    </ng-container>
  </button>
  <mat-autocomplete class="dropdown-panel" #matDropdown="matAutocomplete">
    <ng-container *ngIf="autocompleteHits$ | async as filtered">
      <mat-option *ngFor="let option of filtered.items" [value]="option" (click)="selectChoice(option)">
        <ng-container [ngSwitch]="$any(option)?.type?.id">
          <ng-container *ngSwitchCase="'person'">
            <search-title
              *ngIf="!$any(option)?.title?.toLowerCase().includes('team')"
              stylesAccentColour="publish-colour"
            >
              <ng-container image>
                <elements-image-base
                  size="30px"
                  [imageUrl]="'https://profile-images.internal.brafton.com/profile-images/profile-image-' + $any(option)?.user?.id + '.jpg'"
                ></elements-image-base>
              </ng-container>
              <ng-container top>
                <span [innerHtml]="option?.highlight?.['owner'] || $any(option)?.user?.name"></span
              ></ng-container>
              <ng-container bottom> <mat-icon>people</mat-icon> {{$any(option)?.type?.name}} </ng-container>
            </search-title>

            <search-title
              *ngIf="$any(option)?.title?.toLowerCase().includes('team')"
              stylesAccentColour="publish-colour"
            >
              <ng-container image>
                <elements-image-base size="30px" imageUrl="/assets/images/fallback/generic.png"></elements-image-base>
              </ng-container>
              <ng-container top>
                <span [innerHtml]="option?.highlight?.['owner'] || $any(option)?.organization?.name"></span
              ></ng-container>
              <ng-container bottom> <mat-icon>people</mat-icon> Team </ng-container>
            </search-title>
          </ng-container>

          <ng-container *ngSwitchCase="'organization'">
            <search-title stylesAccentColour="slate">
              <ng-container image>
                <mat-icon>corporate_fare</mat-icon>
              </ng-container>
              <ng-container top>
                <span [innerHtml]="option?.highlight?.['owner'] || $any(option)?.organization?.name"></span
              ></ng-container>
              <ng-container bottom> <mat-icon>corporate_fare</mat-icon> {{$any(option)?.type?.name}} </ng-container>
            </search-title>
          </ng-container>

          <ng-container *ngSwitchCase="'contract'">
            <search-title stylesAccentColour="not-tiffany">
              <ng-container image>
                <mat-icon>receipt</mat-icon>
              </ng-container>
              <ng-container top>
                <span [innerHtml]="option?.highlight?.['owner'] || $any(option)?.organization?.name"></span>
              </ng-container>
              <ng-container bottom> <mat-icon>receipt</mat-icon> {{$any(option)?.type?.name}} </ng-container>
            </search-title>
          </ng-container>

          <ng-container *ngSwitchCase="'comment'">
            <search-title stylesAccentColour="orange">
              <ng-container image>
                <mat-icon>message</mat-icon>
              </ng-container>
              <ng-container top>
                <span
                  [innerHtml]="option?.highlight?.['owner'] || option?.organization?.name || option?.project?.name"
                ></span
              ></ng-container>
              <ng-container bottom> <mat-icon>message</mat-icon> {{$any(option)?.type?.name}} </ng-container>
            </search-title>
          </ng-container>

          <ng-container *ngSwitchCase="'assetfile'">
            <search-title stylesAccentColour="fresh-caught-salmon">
              <ng-container image>
                <mat-icon>folder</mat-icon>
              </ng-container>
              <ng-container top>
                {{$any(option)?.type?.name}}
                <mat-icon>chevron_right</mat-icon>
                <span [innerHtml]=" $any(option)?.title"></span
              ></ng-container>
              <ng-container bottom>
                <mat-icon>corporate_fare</mat-icon> {{$any(option)?.organization?.name || $any(option)?.project?.name}}
              </ng-container>
            </search-title>
          </ng-container>

          <ng-container *ngSwitchCase="'textset'">
            <search-title stylesAccentColour="not-tiffany">
              <ng-container image>
                <mat-icon>description</mat-icon>
              </ng-container>
              <ng-container top>
                {{$any(option)?.project?.name}}
                <mat-icon>chevron_right</mat-icon>
                <span [innerHtml]=" $any(option)?.title"></span
              ></ng-container>
              <ng-container bottom>
                <mat-icon>corporate_fare</mat-icon> {{$any(option)?.organization?.name || $any(option)?.project?.name}}
              </ng-container>
            </search-title>
          </ng-container>

          <ng-container *ngSwitchCase="'content'">
            <search-title stylesAccentColour="purple">
              <ng-container image>
                <mat-icon>picture_in_picture</mat-icon>
              </ng-container>
              <ng-container top>
                {{$any(option)?.type?.name}}
                <mat-icon>chevron_right</mat-icon>
                <span [innerHtml]=" $any(option)?.title"></span
              ></ng-container>
              <ng-container bottom>
                <mat-icon>corporate_fare</mat-icon> {{$any(option)?.organization?.name || $any(option)?.project?.name}}
              </ng-container>
            </search-title>
          </ng-container>

          <ng-container *ngSwitchCase="'campaign'">
            <search-title stylesAccentColour="armageddon-dust">
              <ng-container image>
                <mat-icon>campaign</mat-icon>
              </ng-container>
              <ng-container top> <span [innerHtml]="$any(option)?.title"></span></ng-container>
              <ng-container bottom>
                <mat-icon>campaign</mat-icon> {{$any(option)?.organization?.name}}
                <mat-icon *ngIf="$any(option)?.organization?.name">chevron_right</mat-icon>
                Campaign
              </ng-container>
            </search-title>
          </ng-container>

          <ng-container *ngSwitchCase="'project'">
            <ng-container
              *ngIf="$any(option)?.type !== 'StatementOfWork' && $any(option)?.project?.module !== 'Campaign'"
            >
              <search-title stylesAccentColour="tuscan-sun">
                <ng-container image>
                  <mat-icon>dataset</mat-icon>
                </ng-container>
                <ng-container top> <span [innerHtml]="$any(option)?.project?.name "></span></ng-container>
                <ng-container bottom>
                  <mat-icon>corporate_fare</mat-icon> {{$any(option)?.organization?.name || "Project"}}
                </ng-container>
              </search-title>
            </ng-container>

            <ng-container *ngIf="$any(option)?.type === 'StatementOfWork'">
              <search-title stylesAccentColour="not-tiffany">
                <ng-container image>
                  <mat-icon>receipt</mat-icon>
                </ng-container>
                <ng-container top> <span [innerHtml]="$any(option)?.title"></span></ng-container>
                <ng-container bottom>
                  <mat-icon>receipt</mat-icon> {{$any(option)?.organization?.name || 'Contract'}}
                </ng-container>
              </search-title>
            </ng-container>

            <ng-container
              *ngIf="$any(option)?.type !== 'StatementOfWork' && $any(option)?.project?.module === 'Campaign'"
            >
              <search-title stylesAccentColour="armageddon-dust">
                <ng-container image>
                  <mat-icon>campaign</mat-icon>
                </ng-container>
                <ng-container top> <span [innerHtml]="$any(option)?.title"></span></ng-container>
                <ng-container bottom>
                  <mat-icon>campaign</mat-icon> {{$any(option)?.organization?.name}}
                  <mat-icon *ngIf="$any(option)?.organization?.name">chevron_right</mat-icon>
                  Campaign
                </ng-container>
              </search-title>
            </ng-container>
          </ng-container>

          <ng-container *ngSwitchDefault>
            <search-title stylesAccentColour="fresh-caught-salmon">
              <ng-container image>
                <mat-icon>not_listed_location</mat-icon>
              </ng-container>
              <ng-container top>
                {{$any(option)?.type?.name}}
                <mat-icon *ngIf="$any(option)?.title">chevron_right</mat-icon>
                <span [innerHtml]=" $any(option)?.title"></span
              ></ng-container>
              <ng-container bottom>
                <mat-icon>not_listed_location</mat-icon> {{$any(option)?.organization?.name ||
                $any(option)?.project?.name}}
              </ng-container>
            </search-title>
          </ng-container>
        </ng-container>
      </mat-option>
      <!-- <mat-option *ngFor="let suggest of updateSuggestions(filtered.suggest)">
        <elements-view-option-chip caption="Test"> </elements-view-option-chip>
      </mat-option> -->
    </ng-container>
  </mat-autocomplete>
</mat-form-field>
